import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Stack, Typography, TextField } from '@mui/material';
import { SmallFormTextField } from '../../../../../../components/small-fields/SmallFormTextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DateTimePicker from '@mui/lab/DateTimePicker';
import { formatDateTime } from '../../../../../../services/functions';

const OLOrderDetailsForm = ({ formik }) => {
  const { order } = useSelector(state => state.orderData);

  return (
    <Box display="flex" flexDirection="row" justifyContent="space-between" mt={1}>
      <Stack justifyContent="space-around" spacing={1} sx={{ width: '50%' }}>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2">Numer Zamówienia</Typography>
          <SmallFormTextField
            error={formik.errors.identifier && formik.touched.identifier}
            name="identifier"
            placeholder="numer zamówienia"
            value={formik.values.identifier}
            onChange={formik.handleChange}
            helperText={formik.errors.identifier}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2">Data zamówienia</Typography>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
              name="created_at"
              ampm={false}
              inputFormat="yyyy-MM-dd HH:mm"
              mask="____-__-__ __:__"
              label="data zamówienia"
              value={formik.values.created_at}
              onChange={val => formik.setFieldValue('created_at', formatDateTime(val))}
              renderInput={params => <TextField size="small" sx={{ width: '60%' }} {...params} />}
            />
          </LocalizationProvider>
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2">Ośrodek</Typography>
          <SmallFormTextField
            select
            name="resort"
            placeholder="ośrodek"
            options={order.resort_event_camp_data.resorts}
            value={formik.values.resort}
            onChange={e => {
              formik.handleChange(e);
              formik.setFieldValue('event', '');
              formik.setFieldValue('camp', '');
              formik.setFieldValue('transport_departure_object', '');
              formik.setFieldValue('transport_return_object', '');
            }}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2">Przedział wiekowy</Typography>
          <SmallFormTextField
            placeholder="przedział wiekowy"
            value={order.age_range}
            readOnly={true}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2">Impreza</Typography>
          <SmallFormTextField
            select
            name="event"
            placeholder="impreza"
            options={order.resort_event_camp_data.events[formik.values.resort]}
            value={formik.values.event}
            onChange={formik.handleChange}
            error={formik.touched.event && Boolean(formik.errors.event)}
            helperText={formik.touched.event && formik.errors.event}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2">Turnus</Typography>
          <SmallFormTextField
            select
            name="camp"
            placeholder="turnus"
            options={order.resort_event_camp_data.camps[formik.values.event]}
            value={formik.values.camp}
            onChange={formik.handleChange}
            error={formik.touched.camp && Boolean(formik.errors.camp)}
            helperText={formik.touched.camp && formik.errors.camp}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2">Transport wyjazd</Typography>
          <SmallFormTextField
            select
            name="transport_departure_object"
            placeholder="transport wyjazd"
            options={order.resort_event_camp_data.transports[formik.values.camp]}
            value={formik.values.transport_departure_object}
            onChange={formik.handleChange}
            error={formik.touched.transport_departure_object && Boolean(formik.errors.transport_departure_object)}
            helperText={formik.touched.transport_departure_object && formik.errors.transport_departure_object}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2">Transport powrót</Typography>
          <SmallFormTextField
            select
            name="transport_return_object"
            placeholder="transport powrót"
            options={order.resort_event_camp_data.transports[formik.values.camp]}
            value={formik.values.transport_return_object}
            onChange={formik.handleChange}
            error={formik.touched.transport_return_object && Boolean(formik.errors.transport_return_object)}
            helperText={formik.touched.transport_return_object && formik.errors.transport_return_object}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2" fontSize={12}>Transport rezerwowy</Typography>
          <SmallFormTextField
            select
            name="transport_reserve_object"
            placeholder="transport rezerwowy"
            options={order.resort_event_camp_data.transports[formik.values.camp]}
            value={formik.values.transport_reserve_object}
            onChange={formik.handleChange}
            error={formik.touched.transport_reserve_object && Boolean(formik.errors.transport_reserve_object)}
            helperText={formik.touched.transport_reserve_object && formik.errors.transport_reserve_object}
          />
        </Stack>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} sx={{ width: '50%' }}>
        <Typography variant="subtitle2">Uwagi</Typography>
        <SmallFormTextField name="comments" placeholder="uwagi" multiline rows={16} value={formik.values.comments} onChange={formik.handleChange} />
      </Stack>
    </Box>
  );
};

export default OLOrderDetailsForm;
